import React, { useEffect } from 'react'

// react redux
import { connect } from "react-redux";

// react router
import { useHistory } from "react-router-dom";

export default function WithLoginCheck(WrappedComponent) {
    function HocComponent({ ...props }) {
        // props
        const { isUserAuthenticated } = props

        // consts
        const history = useHistory();

        useEffect(() => {
            if (isUserAuthenticated) {
                history.push('/home')
            }
        }, [isUserAuthenticated, history])

        return (
            <React.Fragment>
                <WrappedComponent {...props} />
            </React.Fragment>
        )
    }

    const getDataFromStore = (state) => {
        return {
            isUserAuthenticated: state.auth.isUserAuthenticated,
        };
    };

    return connect(getDataFromStore, null)(HocComponent)
}